// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"21589aa2","52":"cc1dabf9","119":"5dd7ca7d","221":"f63d8f03","239":"5820590d","318":"519bc1d4","322":"d4849f11","423":"ae8e0cfb","455":"09a6c312","913":"621536df","977":"ae20639b"}[chunkId] + ".chunk.js";
};